import SectionLabel from "../common/SectionLabel";
import ExperienceItem from "./ExperienceItem";
import { experience } from "../../data/experience";

function Experience() {
  return (
    <section id="experience" className="divider">
      <div className="wrap">
        <SectionLabel label="experience" />
        <div className="experience-list">
          {experience.map((item) => (
            <ExperienceItem item={item} key={item.slug} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
